import React from 'react';
import PropTypes from 'prop-types';

export default function UserIcon(props) {
  const { fill, width, height, className } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 16.666 15.292'
      className={className}
    >
      <g id='Grupo_12322' data-name='Grupo 12322' transform='translate(-327 -265)'>
        <path
          id='Caminho_11903'
          data-name='Caminho 11903'
          d='M467.4,486.456a2.673,2.673,0,0,0-1.68-4.756,3.151,3.151,0,0,0-.541.057c-.028,0-.057.029-.085.029a2.8,2.8,0,0,0-.456.142h-.029a2.9,2.9,0,0,0-.854.6,2.635,2.635,0,0,0-.74,1.823,3.489,3.489,0,0,0,.057.541h0a2.738,2.738,0,0,0,.313.8c.028.029.057.085.085.114a2.861,2.861,0,0,0,.541.627,3.985,3.985,0,0,0-1.709,3.617v1.225h6.721v-1.225A3.754,3.754,0,0,0,467.4,486.456Z'
          transform='translate(-125.362 -211.033)'
          fill={fill}
        />
        <path
          id='Caminho_11904'
          data-name='Caminho 11904'
          d='M448.525,466.556a2.626,2.626,0,0,0-.854.826,3.748,3.748,0,0,1,1.281,2.791,4.223,4.223,0,0,1-.085.541h2.648a3.071,3.071,0,0,1-.085-.541,3.748,3.748,0,0,1,1.281-2.791,3.338,3.338,0,0,0-.854-.826,2.691,2.691,0,1,0-3.332,0Z'
          transform='translate(-114.776 -196.8)'
          fill={fill}
        />
        <path
          id='Caminho_11905'
          data-name='Caminho 11905'
          d='M432.5,486.527a2.261,2.261,0,0,0,.541-.627c.028-.029.057-.085.085-.114a2.737,2.737,0,0,0,.313-.8h0a3.151,3.151,0,0,0,.057-.541,2.634,2.634,0,0,0-.74-1.823,2.313,2.313,0,0,0-.854-.6h-.028a2.134,2.134,0,0,0-.456-.142c-.028,0-.057-.029-.085-.029a3.486,3.486,0,0,0-.541-.057,2.674,2.674,0,0,0-2.677,2.677,2.752,2.752,0,0,0,1,2.079,3.985,3.985,0,0,0-1.709,3.617V491.4h6.721v-1.225A3.8,3.8,0,0,0,432.5,486.527Z'
          transform='translate(-100.4 -211.104)'
          fill={fill}
        />
      </g>
    </svg>
  );
}

UserIcon.defaultProps = {
  fill: '#cacaca',
  width: 16.666,
  height: 15.292
};

UserIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};
